import cloneDeep from "lodash/fp/cloneDeep";
import filter from "lodash/fp/filter";
import flatMap from "lodash/fp/flatMap";
import flow from "lodash/fp/flow";
import forEach from "lodash/fp/forEach";
import get from "lodash/fp/get";
import getOr from "lodash/fp/getOr";
import map from "lodash/fp/map";
import rangeStep from "lodash/fp/rangeStep";
import toNumber from "lodash/fp/toNumber";
import _tap from "lodash/fp/tap";

const createRange = (n) => {
  const step = 0.25;
  let min = n ? n - 1 : 4;
  if (n >= 3 && n < 4) {
    min = 3;
  }
  const max = n ? n + 2.25 : 12.25;
  return rangeStep(step)(min)(max);
};

export default function updateFormDataFromVolumentalData(volumentalData) {
  return (initialFormData) => {
    const formData = cloneDeep(initialFormData);

    // add hint for recommended boot length size
    flow(
      getOr([], "products"),
      flatMap(getOr([], "customisations")),
      filter(({ fields }) =>
        fields.find(({ name }) => ["size_left", "size_right"].includes(name))
      ),
      forEach((customisation) => {
        customisation["t|hint"] = {
          translationKey: `Recommended Left: {{recommendedSizeLeft}} Recommended Right: {{recommendedSizeRight}}`,
          translationProps: {
            recommendedSizeLeft: get(["recommended_skate", "size_left"])(
              volumentalData
            ),
            recommendedSizeRight: get(["recommended_skate", "size_right"])(
              volumentalData
            ),
          },
        };
      })
    )(formData);

    const allFields = flow(
      getOr([], "products"),
      flatMap(getOr([], "customisations")),
      flatMap(getOr([], "fields"))
    )(formData);

    // create options for SkateBootLength
    ["size_left", "size_right"].forEach((size) => {
      allFields
        .filter(({ name }) => name === size)
        .forEach((field) => {
          field.options = flow(
            get(["recommended_skate", size]),
            toNumber,
            createRange,
            map((n) => n.toFixed(2)),
            map((value) => ({
              value,
              label: value,
            }))
          )(volumentalData);
        });
    });

    // update options and defaultValue for size_left, size_right & Fit
    ["size_left", "size_right", "Fit"].forEach((fieldName) => {
      allFields
        .filter(({ name }) => name === fieldName)
        .forEach((field) => {
          const recommendedValue = get([
            "recommended_skate",
            fieldName.toLowerCase(),
          ])(volumentalData);

          const recommendedOption = field.options.find(
            ({ value }) => value === recommendedValue
          );

          if (recommendedOption) {
            field.defaultValue = recommendedValue;
            recommendedOption.isRecommended = true;
          }
        });
    });

    return formData;
  };
}
